import Loading from "common/fragments/Loading";
import { Query } from "core/api/typedQuery";
import { IPanelProps, Panel } from "core/decorators/Panel";
import * as React from "react";
import { FlexJustify } from "../../common/fragments/Flex";
import { BlockView } from "../../common/views/block/BlockView.view";
import { iDef } from "../../core/util/TypeUtils";
import BundleEntriesParams from "../bundleEntries/params/BundleEntriesParams";
import TopicComponent from "./component/topic/TopicComponent";
import TopicComponentConfig from "./component/topic/TopicComponentConfig";
import TopicDisplayMode from "./component/topic/TopicDisplayMode";
import Topic from "./entity/Topic";
import TopicsPanelConfig from "./config/TopicsPanelConfig";

const TopicsQuery = Query.queryMany<Topic, any>(Topic);

const PARAM_TOPICS_PAGE_SIZE = "entriesPageSize";

@Panel({id: "forumTopics", configClass: TopicsPanelConfig, pageParams: true})
class TopicsPanel extends React.Component<IPanelProps<TopicsPanelConfig>> {

	public render() {
		const { config, pageParams } = this.props;

		let pageSize = parseInt(pageParams[PARAM_TOPICS_PAGE_SIZE], 10);
		if (isNaN(pageSize)) {
			pageSize = 20;
		}

		const query = null;

		const sort = null;

		const params: BundleEntriesParams = {};
		iDef(pageParams[PARAM_TOPICS_PAGE_SIZE], (v) => params.pageSize = v);
		iDef(pageParams['entries.sort'], (v) => params.sort = v);
		iDef(pageParams['query'], (v) => params.query = v);
		iDef(pageParams.tags, (v) => params.tags = v);

		return (
			<React.Fragment>
				<BlockView viewKey="refine">
					<FlexJustify>
						<div>
							{query}
						</div>
						<div>
							{sort}
						</div>
					</FlexJustify>
				</BlockView>
				<TopicsQuery params={{}}>
					{
						({data, loading}) => {

							if(loading) {
								return <Loading />;
							}

							if(!data) {
								return "No Topics";
							}

							return data.map((topic) => (
								<TopicComponent
									mode={TopicDisplayMode.OVERVIEW}
									key={topic.id}
									config={{...config.topicConfig, topicLayout: config.topicLayout}}
									listConfig={config.listConfig}
									topic={topic}
								/>
							));
						}
					}
				</TopicsQuery>
			</React.Fragment>
		);
	}

	private onParamChange = (name: string) => (value: any) => {
		if (iDef(value)) {
			this.props.actions.pushPageParam(name, value);
		} else {
			this.props.actions.removePageParam(name);
		}
	}
}



// WEBPACK FOOTER //
// ./src/panels/forum/Topics.panel.tsx